$bp-medium: 990px;

.header {
  display: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 4rem;
  padding: 0 1.6rem;
  border-bottom: 1px var(--content-border-color) solid;

  @media screen and (min-width: $bp-medium) {
    display: flex;
  }
}

.title {
  font-family: Inter, sans-serif;
  color: #e3e4e7;
  font-size: 1.3rem;
  letter-spacing: 0.1px;
  line-height: 4.2rem;
}

.items {
  display: flex;
  gap: .8rem;
}
